import { FC, MouseEvent } from 'react';
import { Button } from '../../../components/ui';
import { Step } from './types';

type ControlsProps = {
    steps: Step[];
    isHideOnInactive?: boolean;
    isFirstStep: boolean;
    isLastStep: boolean;
    isValidStep: boolean;
    onGoToPreviousStep: (event: MouseEvent<HTMLButtonElement>) => void;
    onGoToNextStep: (event: MouseEvent<HTMLButtonElement>) => void;
    onCompleteFinalStep: (event: MouseEvent<HTMLButtonElement>) => void;
};

const styles = {
    btn: 'rounded-lg focus:border-4 disabled:opacity-50 disabled:pointer-events-none p-2 pl-5 pr-5 text-lg _bg-blue-500 _border-blue-300 _text-gray-100 theme-button'
};

const NavigationControls: FC<ControlsProps> = 
    ({ steps, isHideOnInactive, isFirstStep, isLastStep, isValidStep, onGoToPreviousStep, onGoToNextStep, onCompleteFinalStep }: ControlsProps) => {
        const handlePreviousStep = (event: MouseEvent<HTMLButtonElement>) => {
            if (onGoToPreviousStep) {
                onGoToPreviousStep(event);
            }
        };
        const handleNextStep = (event: MouseEvent<HTMLButtonElement>) => {
            if (onGoToNextStep) {
                onGoToNextStep(event);
            }
        };
        const handleFinalStep = (event: MouseEvent<HTMLButtonElement>) => {
            if (onCompleteFinalStep) {
                onCompleteFinalStep(event);
            }
        };
        
        if (isHideOnInactive) {
            return null;
        }
        
        return (
            <div className="flex m-auto gap-2">
                {!isFirstStep && (
                    <Button
                        color="primary"
                        onClick={handlePreviousStep}
                        disabled={isFirstStep || steps.length === 0}
                        className={styles.btn}
                    >
                        Back
                    </Button>
                )}

                {!isLastStep && (
                    <Button
                        color="primary"
                        onClick={handleNextStep}
                        disabled={!isValidStep || isLastStep || steps.length === 0}
                        className={styles.btn}
                    >
                        Next
                    </Button>
                )}

                {isLastStep && (
                    <Button
                        color="primary"
                        onClick={handleFinalStep}
                        disabled={!isValidStep || !isLastStep || steps.length === 0}
                        className={styles.btn}
                    >
                        Submit
                    </Button>
                )}
            </div>
        );
    };

export default NavigationControls;